import { render, staticRenderFns } from "./employee_policies.vue?vue&type=template&id=4efe89b5&"
import script from "./employee_policies.vue?vue&type=script&lang=js&"
export * from "./employee_policies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports